import { TFAEndpointMeta } from '../types';

export const isTFAEndpointMeta = (meta: unknown): meta is TFAEndpointMeta =>
  typeof meta === 'object' &&
  meta !== null &&
  ('shouldSignOutOnTFAError' in meta || 'shouldHideTFADialog' in meta);
